<template>
  <el-dialog :visible.sync="isOpen" custom-class="b-condition-search-more b-condition-log-more" width="350px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
    <template slot="title">
      <h1 class="title">搜索更多</h1>
      <i class="iconfont iconguanbi" @click="close"></i>
    </template>
    <div class="search-for-more clearfix">
      <div class="b-con-form">
        <label class="c-label">状态：</label>
        <el-select class="c-input-area" v-model="parameter.status" placeholder="请选择" clearable>
          <el-option value="" label="全部"></el-option>
          <el-option v-for="(type, key) in options.admin_join_status_search" :key="key" :value="key" :label="type"></el-option>
        </el-select>
      </div>
    </div>
    <div slot="footer" class="more-condition-footer">
      <button class="global-btn info-round" @click="close">取消</button>
      <button class="global-btn primary-round" @click="resetCondition">重置</button>
      <button class="global-btn primary" @click="check">选择</button>
    </div>
  </el-dialog>
</template>
<script>
import { configKeys } from '@/setting/index';
export default{
  name: 'ApproveMemberCondition',
  props: {
    isOpen: Boolean
  },
  data () {
    return {
      parameter: {
        status: ''
      },
      options: {}
    }
  },
  async created() {
    this.options = await this.$store.dispatch('initConfig', [configKeys.admin_join_status_search]);
  },
  methods: {
    close () {
      this.$emit('update:isOpen', false);
    },
    resetCondition () {
      this.parameter = {
        status: ''
      }
      this.$emit('reset', this.parameter);
      this.close(); 
    },
    check () {
      this.$emit('comfirmCheck', this.parameter);
      this.close(); 
    }
  },
}
</script>
<style lang="less" scoped>
/* 无效池搜索覆盖样式 */
.b-condition-search-more.b-condition-log-more{
  .search-for-more .c-label{
    width: 60px;
  }
  .b-con-form{
    width: 100%;
    margin-right: 0;
    padding-left: 0;
  }
}
</style>